import React from 'react';
import { COMPANY } from '@ApplicationWide/routes/route-groups';
import { UserFileIcon } from '@Generic/icons';
const PeoplePage = React.lazy(() => import('../../../pages/Company/People'));

export default {
  label: 'people-page.title',
  group: COMPANY,
  to: '/company/people',
  route: '/company/people',
  area: 'people', // Area is used to check if user has permission to view that Page or not, in case of no area given the page is always visible.
  component: PeoplePage,
  icon: <UserFileIcon />,
  appearsInNavBar: true,
  hasNavBar: true,
};
